import { ParsedUrlQuery } from 'querystring';

export function getIncludeSold(query: ParsedUrlQuery) {
    if (query['include_sold']) {
        return query['include_sold'];
    }

    return '';
}
